export type DishPlanItem = {
  "@id": string;
  "@type": string;
  id: number;
  date: `${number}-${number}-${number}`;
  dishType: "DEFAULT" | "DESSERT";
  mealType: "VEGETARIAN" | "MEAT" | "FISH";
  position: number;
  title: string;
  dishPlanId?: number;
};

export type DishPlan = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  items: DishPlanItem[];
  month: number;
  name: string;
  submissionDeadline: string;
  year: number;
};

export type DishPlanDocument = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  document: string;
  month: number;
  year: number;
};

export type SchoolDishPlanInput = {
  items: DishPlanItem["@id"][];
  month: number;
  year: number;
};

export type SchoolDishPlan = Omit<DishPlan, "name" | "submissionDeadline">;
